/** Session / OTP window for MFA setup and login authenticator (TOTP) PIN step (5 minutes). */
export const MFA_SETUP_AND_AUTHENTICATOR_OTP_TTL_MS = 5 * 60 * 1000;

/** Shown when the MFA / authenticator countdown completes (email OTP keeps separate copy in VerificationForm). */
export const MFA_SESSION_EXPIRED_MESSAGE = "Session expired.";
